"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PIXIText = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _pixi = require("pixi.js");
var _PIXITextStyle = _interopRequireDefault(require("./PIXITextStyle"));
var _PIXIGlobal = require("../init/PIXIGlobal");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0, _get2["default"])((0, _getPrototypeOf2["default"])(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; } /**
 * createjs 의 rendeeing 방식을 따라 하기 위해 fontProperty를 사용안함.
 * 뷰의 스케일 조정을 하더라도 깔끔하게 보이기 위해 fontScale 를 추가하여 텍스쳐의 크기를 조절함.
 */
var $textCanvasContainer;
var PIXIText = exports.PIXIText = /*#__PURE__*/function (_Text) {
  function PIXIText(text, style) {
    var _this;
    (0, _classCallCheck2["default"])(this, PIXIText);
    var canvas = document.createElement('canvas');
    if (!$textCanvasContainer) {
      $textCanvasContainer = $('#textCanvasContainer');
    }
    $textCanvasContainer.append(canvas);
    _this = _callSuper(this, PIXIText, [text, style, canvas]);
    _this.setFontScaleX(1);
    _this.setFontScaleY(1);
    _PIXIGlobal.PIXIGlobal.fontLoadChecker.manage(_this);
    return _this;
  }
  (0, _inherits2["default"])(PIXIText, _Text);
  return (0, _createClass2["default"])(PIXIText, [{
    key: "style",
    get: function get() {
      return _superPropGet(PIXIText, "style", this, 1);
    },
    set: function set(style) {
      // eslint-disable-line require-jsdoc
      style = style || {};
      if (style instanceof _PIXITextStyle["default"]) {
        this._style = style;
      } else {
        this._style = new _PIXITextStyle["default"](style);
      }
      this.localStyleID = -1;
      this.dirty = true;
    }
  }, {
    key: "setFontScaleX",
    value: function setFontScaleX(value) {
      value = value * PIXIText.STAGE_SCALE;
      this._fontScaleX = value;
      this.scale.x = 1 / value;
      this.dirty = true;
    }
  }, {
    key: "setFontScaleY",
    value: function setFontScaleY(value) {
      value = value * PIXIText.STAGE_SCALE;
      this._fontScaleY = value;
      this.scale.y = 1 / value;
      this.dirty = true;
    }
  }, {
    key: "getMeasuredWidth",
    value: function getMeasuredWidth() {
      this.updateText(true);
      return this._measuredWidth;
    }
  }, {
    key: "getMeasuredHeight",
    value: function getMeasuredHeight() {
      this.updateText(true);
      return this._measuredHeight;
    }
  }, {
    key: "getMeasuredLineHeight",
    value: function getMeasuredLineHeight() {
      this.updateText(true);
      return this._measuredLineHeight;
    }

    /** @deprecated */
  }, {
    key: "measuredWidth",
    get: function get() {
      this.updateText(true);
      console.warn('[deprecated] - PIXIText.measuredWidth');
      return this._measuredWidth;
    }
    /** @deprecated */
  }, {
    key: "measuredHeight",
    get: function get() {
      this.updateText(true);
      console.warn('[deprecated] - PIXIText.measuredHeight');
      return this._measuredHeight;
    }
    /** @deprecated */
  }, {
    key: "measuredLineHeight",
    get: function get() {
      this.updateText(true);
      console.warn('[deprecated] - PIXIText.measuredLineHeight');
      return this._measuredLineHeight;
    }

    /**
     * Renders text and updates it when needed.
     *
     * @private
     * @param {boolean} respectDirty - Whether to abort updating the text if the Text isn't dirty and the function is called.
     */
  }, {
    key: "updateText",
    value: function updateText(respectDirty) {
      var style = this._style;

      // check if style has changed..
      if (this.localStyleID !== style.styleID) {
        this.dirty = true;
        this.localStyleID = style.styleID;
      }
      if (!this.dirty && respectDirty) {
        return;
      }
      this._font = this._style.toFontString();
      var context = this.context;
      var measured = _pixi.TextMetrics.measureText(this._text, this._style, this._style.wordWrap, this.canvas);
      var width = this._measuredWidth = measured.width;
      var height = this._measuredHeight = measured.height;
      var lines = measured.lines;
      var lineHeight = this._measuredLineHeight = measured.lineHeight;
      var lineWidths = measured.lineWidths;
      var maxLineWidth = measured.maxLineWidth;
      var fontProperties = measured.fontProperties;
      var UN = undefined;
      var FSX = this._fontScaleX === UN ? 1 : this._fontScaleX;
      var FSY = this._fontScaleY === UN ? 1 : this._fontScaleY;
      this.canvas.width = Math.ceil((Math.max(1, width) + style.padding * 2) * this.resolution * FSX);
      this.canvas.height = Math.ceil((Math.max(1, height) + style.padding * 2) * this.resolution * FSY);
      context.scale(this.resolution * FSX, this.resolution * FSY);
      context.clearRect(0, 0, this.canvas.width, this.canvas.height);
      //---------- DEBUG CODE ------------
      // context.fillStyle = "rgba(255, 0, 0, 0.3)";
      // context.fillRect(0, 0, this.canvas.width, this.canvas.height);
      //---------- DEBUG CODE ------------

      context.font = this._font;
      context.strokeStyle = style.stroke;
      context.lineWidth = style.strokeThickness;
      context.textBaseline = style.textBaseline;
      context.lineJoin = style.lineJoin;
      context.miterLimit = style.miterLimit;
      var linePositionX;
      var linePositionY;
      if (style.dropShadow) {
        context.fillStyle = style.dropShadowColor;
        context.globalAlpha = style.dropShadowAlpha;
        context.shadowBlur = style.dropShadowBlur;
        if (style.dropShadowBlur > 0) {
          context.shadowColor = style.dropShadowColor;
        }
        var xShadowOffset = Math.cos(style.dropShadowAngle) * style.dropShadowDistance;
        var yShadowOffset = Math.sin(style.dropShadowAngle) * style.dropShadowDistance;
        for (var i = 0; i < lines.length; i++) {
          linePositionX = style.strokeThickness / 2;
          linePositionY = style.strokeThickness / 2 + i * lineHeight + fontProperties.ascent;
          if (style.align === 'right') {
            linePositionX += maxLineWidth - lineWidths[i];
          } else if (style.align === 'center') {
            linePositionX += (maxLineWidth - lineWidths[i]) / 2;
          }
          if (style.fill) {
            this.drawLetterSpacing(lines[i], linePositionX + xShadowOffset + style.padding, linePositionY + yShadowOffset + style.padding);
            if (style.stroke && style.strokeThickness) {
              context.strokeStyle = style.dropShadowColor;
              this.drawLetterSpacing(lines[i], linePositionX + xShadowOffset + style.padding, linePositionY + yShadowOffset + style.padding, true);
              context.strokeStyle = style.stroke;
            }
          }
        }
      }

      // reset the shadow blur and alpha that was set by the drop shadow, for the regular text
      context.shadowBlur = 0;
      context.globalAlpha = 1;

      // set canvas text styles
      context.fillStyle = this._generateFillStyle(style, lines);
      var WORD_WRAP = style.wordWrap;
      var H_LH = lineHeight * 0.5; // half line-height
      var MAX_HEIGHT = style.maxHeight < 0 ? 0xffff : style.maxHeight - H_LH;
      var PAD = style.padding;
      // draw lines line by line
      for (var _i = 0; _i < lines.length; _i++) {
        linePositionX = style.strokeThickness / 2;
        linePositionY = style.strokeThickness / 2 + _i * lineHeight + H_LH;
        if (WORD_WRAP && linePositionY > MAX_HEIGHT) {
          break;
        }
        if (style.align === 'right') {
          linePositionX += maxLineWidth - lineWidths[_i];
        } else if (style.align === 'center') {
          linePositionX += (maxLineWidth - lineWidths[_i]) / 2;
        }
        if (style.stroke && style.strokeThickness) {
          this.drawLetterSpacing(lines[_i], linePositionX + style.padding, linePositionY + style.padding, true);
        }
        if (style.fill) {
          this.drawLetterSpacing(lines[_i], linePositionX + style.padding, linePositionY + style.padding);
        }

        //취소선 추가
        if (style.cancelLine) {
          this._drawLineAt(context, linePositionX + PAD, linePositionY + PAD, lineWidths[_i], 0);
        }

        //밑줄
        if (style.underLine) {
          this._drawLineAt(context, linePositionX + PAD, linePositionY + PAD, lineWidths[_i], lineHeight * 0.4);
        }
      }
      this.updateTexture();
    }
  }, {
    key: "updateTexture",
    value: function updateTexture() {
      var canvas = this.canvas;

      // 박봉배- entryjs 에서 trim 기능 사용안함. 그리고 trimCanvas 의 참조를 pixi 라이브러리로부터 못갖고 오겠음.
      /*
      if (this._style.trim)
      {
          const trimmed = trimCanvas(canvas);
           if (trimmed.data)
          {
              canvas.width = trimmed.width;
              canvas.height = trimmed.height;
              this.context.putImageData(trimmed.data, 0, 0);
          }
      }
      */

      var texture = this._texture;
      var style = this._style;
      var padding = style.trim ? 0 : style.padding;
      var baseTexture = texture.baseTexture;
      var UN = undefined;
      var FSX = this._fontScaleX === UN ? 1 : this._fontScaleX;
      var FSY = this._fontScaleY === UN ? 1 : this._fontScaleY;
      baseTexture.hasLoaded = true;
      baseTexture.resolution = this.resolution;
      baseTexture.setRealSize(canvas.width, canvas.height);
      baseTexture.setSize(canvas.width, canvas.height, this.resolution);
      texture.trim.width = texture._frame.width = canvas.width / this.resolution;
      texture.trim.height = texture._frame.height = canvas.height / this.resolution;
      texture.trim.x = -padding * FSX;
      texture.trim.y = -padding * FSY;
      texture.orig.width = texture._frame.width - padding * 2 * FSX;
      texture.orig.height = texture._frame.height - padding * 2 * FSY;

      // call sprite onTextureUpdate to update scale if _width or _height were set
      this._onTextureUpdate();
      baseTexture.emit('update', baseTexture);
      this.dirty = false;
    }

    /**
     * 취소선 or 밑줄을 draw 하기 위한 함수.
     * @private
     * @param {CanvasRenderingContext2D} ctx
     * @param x
     * @param y
     * @param width
     * @param offsetY
     */
  }, {
    key: "_drawLineAt",
    value: function _drawLineAt(ctx, x, y, width, offsetY) {
      ctx.fillRect(x, y + offsetY, width, 1);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      $(this.canvas).remove();
      _PIXIGlobal.PIXIGlobal.fontLoadChecker.unmanage(this);
      _superPropGet(PIXIText, "destroy", this, 3)([{
        children: false,
        baseTexture: true,
        texture: true
      }]);
    }
  }]);
}(_pixi.Text); // PIXIText.STAGE_SCALE = 1.51;
PIXIText.STAGE_SCALE = 1.53;
// PIXIText.STAGE_SCALE = 1.41;
// console.log(`PIXIText.STAGE_SCALE1(${PIXIText.STAGE_SCALE})`);